import React from "react";
import { useLocation } from "react-router-dom";
import { CONFIG } from "../../config/api.config";
import { useSelector } from "react-redux";

const RootLoader = () => {
  const logo = useSelector((state) => state.logo);
  const loaderStyles = () => {
    if (window.location.hostname == "lotus365original.com") {
      return { display: "flex", background: "#1e8067" };
    }
    return { display: "flex" };
  };

  return (
    // <div className="divLoader" style={loaderStyles()}>
    <div
      className="divLoader"
      style={{ display: "flex", background: "var(--div-loader-bg)" }}
    >
      <img alt="logo" className="loader-img" id="logoImage" src={logo} />
    </div>
  );
};

export default RootLoader;
